/**
 * Message keys for claim onboarding flow
 */
export enum EClaimMessagesKeys {
  // Step title
  TITLE = "ONBOARDING.CLAIM.TITLE",
  TABNAME = "ONBOARDING.CLAIM.TABNAME",

  // Form block titles
  CLAIM_DETAILS_BLOCK_TITLE = "ONBOARDING.CLAIM.CLAIM_DETAILS_BLOCK_TITLE",
  CLAIM_DETAILS_SUBTITLE = "ONBOARDING.CLAIM.CLAIM_DETAILS_SUBTITLE",
  ADDITIONAL_INFO_BLOCK_TITLE = "ONBOARDING.CLAIM.ADDITIONAL_INFO_BLOCK_TITLE",

  // Field labels
  ACCIDENT_DATE_TITLE = "ONBOARDING.CLAIM.ACCIDENT_DATE_TITLE",
  CLAIM_NUMBER_TITLE = "ONBOARDING.CLAIM.CLAIM_NUMBER_TITLE",
  LICENSE_PLATE_TITLE = "ONBOARDING.CLAIM.LICENSE_PLATE_TITLE",
  VIN_TITLE = "ONBOARDING.CLAIM.VIN_TITLE",
  DRIVER_FIRST_NAME_TITLE = "ONBOARDING.CLAIM.DRIVER_FIRST_NAME_TITLE",
  DRIVER_LAST_NAME_TITLE = "ONBOARDING.CLAIM.DRIVER_LAST_NAME_TITLE",

  // Placeholders
  LICENSE_PLATE_PLACEHOLDER = "ONBOARDING.CLAIM.LICENSE_PLATE_PLACEHOLDER",
  VIN_PLACEHOLDER = "ONBOARDING.CLAIM.VIN_PLACEHOLDER",
  DRIVER_FIRST_NAME_PLACEHOLDER = "ONBOARDING.CLAIM.DRIVER_FIRST_NAME_PLACEHOLDER",
  DRIVER_LAST_NAME_PLACEHOLDER = "ONBOARDING.CLAIM.DRIVER_LAST_NAME_PLACEHOLDER",

  // Consent text for claim flow
  CONSENT_TEXT = "ONBOARDING.CLAIM.CONSENT_TEXT",
  CONSENT_ACKNOWLEDGEMENT_TEXT = "ONBOARDING.CLAIM.CONSENT_ACKNOWLEDGEMENT_TEXT",

  // Summary block
  SUMMARY_CLAIM_INFO_TITLE = "ONBOARDING.CLAIM.SUMMARY_CLAIM_INFO_TITLE",
  SUMMARY_DATE_OF_ACCIDENT = "ONBOARDING.CLAIM.SUMMARY_DATE_OF_ACCIDENT",
  SUMMARY_TABNAME = "ONBOARDING.CLAIM.SUMMARY_TABNAME",
  SUMMARY_TITLE = "ONBOARDING.CLAIM.SUMMARY_TITLE",

  // Congratulations page
  CONGRATS_SUBTITLE = "ONBOARDING.CLAIM.CONGRATS_SUBTITLE",
}
